import React, { useState } from "react";
import {
  LargeButton,
  MainBody,
  PageTitle,
  InsuranceCard,
  UploadedInsuranceCard
} from "components/core";
import { SideNav } from "components";
import { WidthLimiter, FullHeighit, BottonWrapper } from "./styles";
import { useRecoilValue } from "recoil";
import {
  selectedInsuranceProducts,
} from "state/planSetup";
import { useNavigate } from "react-router";
import routes from "components/routes";

const SelectPlan = () => {
  const navigate = useNavigate();
  const [selectedCards, setSelectedCards] = useState([]);
  const selectedProducts = useRecoilValue(selectedInsuranceProducts);
  const noCardsSelected = selectedCards.length === 0; // to check whether any cards are selected or not
  const preSelectedPlan = JSON.parse(localStorage.getItem('selected_plan_document'))
  var uploadedPlan = (JSON.parse(localStorage.getItem('uploaded_plan_document')))
  uploadedPlan = uploadedPlan && uploadedPlan.sort()
 
  const onChange = (selectedCards) => {
    // hiding error on card selection
    setSelectedCards([...selectedCards]);
  };
console.log(preSelectedPlan)
  const onSubmit = () => {
    if (noCardsSelected && !!localStorage.getItem('uploaded_plan_document')) {
      localStorage.removeItem('uploaded_plan_document')
      localStorage.removeItem('selected_plan_document')
      navigate(`/${routes.CARE_DASHBOARD}`); 
      return;
    } else if(noCardsSelected){
      // displaying error and returning if no cards are selected
      return
    }
  };

  return (
    <section>
      <SideNav />
      <MainBody>
        <WidthLimiter>
          {/* <FullHeighit> */}
            <PageTitle title="Upload Employee Data" />
            <div style={{height:"20px"}}/>
            {!!uploadedPlan && <UploadedInsuranceCard list={uploadedPlan} />}
            <InsuranceCard list={preSelectedPlan} onChange={onChange} />
            {/* <BottonWrapper> */}
              <LargeButton
                label="Save & Next"
                opacity={!uploadedPlan && "50%"}
                onClick={onSubmit}
              />
            {/* </BottonWrapper> */}
          {/* </FullHeighit> */}
        </WidthLimiter>
      </MainBody>
    </section>
  );
};

export default SelectPlan;
